<template>
    <div class="reaction">
        <span v-if="selected === answer" class="correct">
            {{ correctText }}
        </span>
        <span v-if="selected !== answer" class="incorrect">
            {{ incorrectText }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        question: String,
        selected: Number,
        answer: Number,
    },
    computed: {
        correctText() {
            const RANDOM = Math.floor(this.question.length + Math.random() * 2) % 2;
            return RANDOM ? '答對了！' : '你好棒！';
        },
        incorrectText() {
            const RANDOM = Math.floor(this.question.length + Math.random() * 2) % 2;
            return RANDOM ? '再接再厲！' : '哇！你答錯囉！';
        },
    },
};
</script>

<style lang="scss" scoped>
.correct {
    background-color: #5ac892;
}
.incorrect {
    background-color: #cf6300;
}
.reaction {
    position: absolute;
    width: 100%;
    text-align: right;
    bottom: 0;
    padding: 10px 20px 0;
    font-size: 20px;
    transform: translateY(100%);
    > * {
        color: #fff;
        padding: 2px 15px;
        border-radius: 18px;
    }
}
</style>
